import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EntryFormRecordData } from '../../models/EntryFormRecordData';
// import type { RootState } from '../store';

const initialState: any = {
  entries: [] as EntryFormRecordData[],
  edittingIndex: -1,
  stepIndex: 0,
  sumEntryFee: 0 as number,
  totalServiceFee: 0 as number,
  sumCatalogFee: 0 as number,
  totalFees: 0 as number,
  agreeToAgreementDate: '',
  payPalOrderHistory: [] as any[]
};

export const entryFormsSlice = createSlice({
  name: 'entryForms',
  initialState,
  reducers: {
    setEntries: (state, action: PayloadAction<EntryFormRecordData[]>) => {
      state.entries = action.payload;
    },
    setEdittingIndex: (state, action: PayloadAction<number>) => {
      state.edittingIndex = action.payload;
    },
    setStepIndex: (state, action: PayloadAction<number>) => {
      state.stepIndex = action.payload;
    },
    setSumEntryFee: (state, action: PayloadAction<number>) => {
      state.sumEntryFee = action.payload;
    },
    setSumCatalogFee: (state, action: PayloadAction<number>) => {
      state.sumCatalogFee = action.payload;
    },
    setTotalServiceFee: (state, action: PayloadAction<number>) => {
      state.totalServiceFee = action.payload;
    },
    setTotalFees: (state, action: PayloadAction<number>) => {
      state.totalFees = action.payload;
    },
    setPayPalOrderHistory: (state, action: PayloadAction<any[]>) => {
      state.payPalOrderHistory = action.payload;
    },
    setAgreeToAgreementDate: (state, action: PayloadAction<string>) => {
      state.agreeToAgreementDate = action.payload;
    },
    setEntryForms: (state, action: PayloadAction<any>) => {
      if (action.payload.entries !== undefined) {
        state.entries = action.payload.entries;
      }
      if (action.payload.edittingIndex !== undefined) {
        state.edittingIndex = action.payload.edittingIndex;
      }
      if (action.payload.stepIndex !== undefined) {
        state.stepIndex = action.payload.stepIndex;
      }
      if (action.payload.sumEntryFee !== undefined) {
        state.sumEntryFee = action.payload.sumEntryFee;
      }
      if (action.payload.sumCatalogFee !== undefined) {
        state.sumCatalogFee = action.payload.sumCatalogFee;
      }
      if (action.payload.totalServiceFee !== undefined) {
        state.totalServiceFee = action.payload.totalServiceFee;
      }
      if (action.payload.totalFees !== undefined) {
        state.totalFees = action.payload.totalFees;
      }
      if (action.payload.edittingIndex !== undefined) {
        state.payPalOrderHistory = action.payload.payPalOrderHistory;
      }
      if (action.payload.agreeToAgreementDate !== undefined) {
        state.agreeToAgreementDate = action.payload.agreeToAgreementDate;
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setAgreeToAgreementDate,
  setEdittingIndex,
  setEntries,
  setEntryForms,
  setPayPalOrderHistory,
  setStepIndex,
  setSumCatalogFee,
  setSumEntryFee,
  setTotalFees,
  setTotalServiceFee
} = entryFormsSlice.actions;

// export const selectRegistrantName = (state: RootState) => state.registrant.name
// export const selectRegistrantEmail = (state: RootState) => state.registrant.email
// export const selectRegistrantAdminPin = (state: RootState) => state.registrant.adminPin

export default entryFormsSlice.reducer;
